import { TrashIcon } from "@/components/_icons/trashIcon";
import React from "react";
import { useTranslations } from "next-intl";

export interface RemoveFromCartButtonProps {
  // eslint-disable-next-line no-unused-vars
  removeFromCart: (event: React.MouseEvent, index: number) => void;
  // eslint-disable-next-line no-unused-vars
  index: number;
  itemName?: string;
}

export const RemoveFromCartButton = ({
  removeFromCart,
  index,
  itemName
}: RemoveFromCartButtonProps) => {
  const t = useTranslations("RemoveFromCartButton")
  return (
    <button
      onClick={(event: React.MouseEvent) => removeFromCart(event, index)}
      className="mt-2"
      aria-label={t("removeItemLabel", {itemName: itemName ?? "item"})}
    >
      <TrashIcon />
    </button>
  );
};
